module.exports = __webpack_public_path__ + "img/bottom_left.8cf703dd.png";